/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 15:25 20.04.2023
 * @ Description: TestPage
 */
import React, { useState, useEffect } from 'react';
import "./index.css"
import MyButton from "../../compenent/button/MyButton";
import GamePageManager from "../../utils/GamePageManager";
import WordButton from "../../compenent/WordButton/WordButton";
import Sentence from "../../GameClass/sentence";
import SentenceError from '../../GameClass/sentenceError';
import api from '../../utils/api';
let erros=[
  new SentenceError("",0,2),
  new SentenceError("",18,20)
]
export default function TestPage() {
  const [sen, setSen] = useState(null);
  const [words, setwords] = useState(null);
  const [answerWords, setanswerWords] = useState(null);


  useEffect(()=>{
  },[])


  return (
    <div className="GamePage TestPage">
        <h1>Testpage</h1>
        <div className="testZone">
          <MyButton title={"test"} fontSize={40} addStyle={{marginTop:"auto",marginBottom:50}} onClick={()=>{
            api.test();
          }}/>
        </div>
        <MyButton title={"Back"} fontSize={40} addStyle={{marginTop:"auto",marginBottom:50}} onClick={()=>GamePageManager.changePage("MainMenu")}/>
        <div></div>
    </div>
  );
}

